import React from 'react';

import { CountryDto } from '@src/meta/types/billing/vat';
import IpResource from '@src/services/Ipapi/IpResource';
import DropdownWithSearch from '@modules/common/components/Field/DropdownWithSearch';

type Props = {
  country?: string;
  setCountry: (country: string) => void;
  getCountries: () => Promise<void>;
  fetchingCountries: boolean;
  countries: CountryDto[];
  error?: boolean;
  label?: string;
  useIp: boolean;
};

const initialState = Object.freeze({
  fetchingCountry: true as boolean,
});

type State = typeof initialState;

class CountryPicker extends React.PureComponent<Props, State> {
  ismounted = false;

  constructor(props: Props) {
    super(props);
    this.state = initialState;
  }

  async componentDidMount() {
    this.ismounted = true;
    await this.props.getCountries();
    if (this.props.useIp && (this.props.country === undefined || this.props.country === '')) {
      try {
        const resp = await IpResource.getCountry();
        if (this.props.country === undefined || this.props.country === '') {
          this.props.setCountry(resp.country.toLowerCase());
        }
      } catch (err) {
        // continue regardless of error
      }
    }

    if (this.ismounted) {
      this.setState({ fetchingCountry: false });
    }
  }

  componentWillUnmount() {
    this.ismounted = false;
  }

  handleCountryChange = (_: any, { value }: any) => {
    this.setState({ fetchingCountry: false });
    this.props.setCountry(`${value}`);
  };

  getCountryOptions = (countries: CountryDto[]) => {
    return countries.map(c => {
      const countryCode = c.id.toLowerCase();
      const text = c.name
        .split(' ')
        .map(t => t.charAt(0) + t.slice(1).toLowerCase())
        .join(' ');

      return {
        value: countryCode,
        flag: countryCode === 'el' ? 'gr' : countryCode,
        key: countryCode,
        text,
      };
    });
  };

  render() {
    const { country, fetchingCountries, countries, error, label } = this.props;
    const { fetchingCountry } = this.state;
    const options = this.getCountryOptions(countries);

    return (
      <DropdownWithSearch
        placeholder="Select Country"
        value={country?.toLowerCase()}
        options={options}
        onChange={this.handleCountryChange}
        loading={fetchingCountry || fetchingCountries}
        disabled={fetchingCountries}
        error={error}
        label={label ?? 'Select a country: '}
        className="country-picker"
        style={{ marginTop: '10px' }}
      />
    );
  }
}

export default CountryPicker;
